import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import PDDAuthContext from "../../store/pddStore/pdd-auth-context";

const RequirePDDFormAuth = () => {
  const location = useLocation();
  const { clientAuthInfo } = useContext(PDDAuthContext);

  return (
    <>
      {clientAuthInfo.isLoggedIn ? (
        <Outlet />
      ) : (
        <Navigate to="/personnel-document-digitization/login" replace state={{ from: location }} />
      )}
    </>
  );
};

export default RequirePDDFormAuth;
